import useMyMontepioContext from "../../../components/Context/useMyMontepioContext";
import { MGButton } from "../../../designSystem/components/MGButton";
import { MGSubtitle } from "../../../designSystem/components/MGSubtitle";
import styles from "../Health.module.css";
import succesStepStyles from "./SuccessStep.module.css";

import medicalPlanSubscription from "../../../images/medicalPlanSubscription.svg";
import medicalSubscription from "../../../images/medicalSubscription.svg";
import { MGText } from "../../../designSystem/components/MGText";
import { BackgroundForm } from "../../../components/BackgroundForm";

type TSuccessStepProps = {
  supplementaryHealthPlan?: boolean;
  onContinue: () => void;
};

export const SuccessStep = ({ onContinue, supplementaryHealthPlan = false }: TSuccessStepProps) => {
  const { isMobileAuth } = useMyMontepioContext();

  return (
    <div style={{ display: "flex", flex: 1, flexDirection: "column" }}>
      <BackgroundForm>
        <MGSubtitle
          subtitleStyleDefinition="200-06"
          style={{ marginTop: 64, marginBottom: 32, textAlign: "center" }}>
          {"Dados registados!"}
        </MGSubtitle>

        <div style={{ justifyContent: "center", display: "flex" }}>
          <img
            alt="imagem de sucesso"
            src={supplementaryHealthPlan ? medicalPlanSubscription : medicalSubscription}
          />
        </div>

        <MGSubtitle subtitleStyleDefinition="100-06" style={{ marginTop: 56, marginBottom: 24 }}>
          {"Subscrição pendente de assinatura dos documentos."}
        </MGSubtitle>

        <MGText textStyleDefinition="body-100-03" style={{ marginBottom: 32 }}>
          Consulte o SMS enviado para o seu telemóvel, e aceda via link ao portal “mTrust”, para
          proceder à assinatura digital dos documentos.
          <br />
          <br />A ausência de assinatura impedirá a efetivação da subscrição.
        </MGText>
      </BackgroundForm>

      <MGButton
        fullWidth={isMobileAuth}
        className={`${styles.buttonFooter} ${succesStepStyles.successButton} ${isMobileAuth ? styles.buttonFooterFixed : ""}`}
        onClick={onContinue}>
        {"Voltar a Modalidades"}
      </MGButton>
    </div>
  );
};
